/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DelegateProfilePage_delegate = {
    readonly uuid: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: string | null;
    readonly jobTitle: string;
    readonly TTC_ID: string;
    readonly profileImageUrl: string | null;
    readonly currentBackgroundCheck: {
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
    } | null;
    readonly hasActiveBackgroundCheck: boolean;
    readonly backgroundCheckPending: boolean;
    readonly backgroundChecks: ReadonlyArray<{
        readonly uuid: string;
        readonly approvalDate: string | null;
        readonly isVerification: boolean;
    }> | null;
    readonly company: {
        readonly name: string;
    };
    readonly hasSimulatorAccess: boolean;
    readonly " $fragmentRefs": FragmentRefs<"CourseTable_delegate" | "DocumentsTable_delegate" | "ProfileCard_delegate" | "BackgroundCheckCard_delegate" | "PendingBackgroundCheckTab_delegate">;
    readonly " $refType": "DelegateProfilePage_delegate";
};
export type DelegateProfilePage_delegate$data = DelegateProfilePage_delegate;
export type DelegateProfilePage_delegate$key = {
    readonly " $data"?: DelegateProfilePage_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_delegate">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "DelegateProfilePage_delegate",
        "type": "Delegate",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "jobTitle",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "TTC_ID",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "profileImageUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "currentBackgroundCheck",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "idExpiryDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dbsExpiryDate",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasActiveBackgroundCheck",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "backgroundCheckPending",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "backgroundChecks",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "approvalDate",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isVerification",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "company",
                "storageKey": null,
                "args": null,
                "concreteType": "Company",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasSimulatorAccess",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CourseTable_delegate",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "DocumentsTable_delegate",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ProfileCard_delegate",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "BackgroundCheckCard_delegate",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "PendingBackgroundCheckTab_delegate",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '95bbfdbae29a0a0a6efeb2787e60630e';
export default node;
